import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue
} from 'vuelidate/lib/validators'
import Vue from 'vue'
import { PandaService, DolphinService } from './utils/request'

class Server extends Vue {
  async loadMetadata (entities) {
    const { data } = await PandaService({
      url: `${entities.Member.url}`,
      method: 'METADATA'
    })
    if (data) {
      window.localStorage.setItem('metadata', JSON.stringify(data))
    }
  }

  async loadOrganizationMetadata (entities) {
    const { data } = await DolphinService({
      url: `${entities.Organization.url}`,
      method: 'METADATA'
    })
    if (data) {
      window.localStorage.setItem('organizationMetadata', JSON.stringify(data))
    }
  }

  get organizationMetadata () {
    return JSON.parse(localStorage.getItem('organizationMetadata'))
  }

  get metadata () {
    return JSON.parse(localStorage.getItem('metadata'))
  }

  get token () {
    return localStorage.getItem('token')
  }

  set token (token) {
    window.localStorage.setItem('token', token)
  }

  logout () {
    window.localStorage.removeItem('token')
  }
}

export function createValidator (options) {
  options = Object.assign({}, this, options || {})
  let result = {}

  if (options.required) {
    result['required'] = required
  }

  if (options.minLength) {
    result['minLength'] = minLength(options.minLength)
  }

  if (options.maxLength) {
    result['maxLength'] = maxLength(options.maxLength)
  }

  if (options.minValue) {
    result['minValue'] = minValue(options.minValue)
  }

  if (options.maxValue) {
    result['maxValue'] = maxValue(options.maxValue)
  }

  if (options.pattern) {
    result['pattern'] = function (value) {
      if (!value || value === '') {
        return true
      }
      return value.match(new RegExp(options.pattern)) !== null
    }
  }
  return result
}

export default new Server()
